export default __webpack_public_path__ + "static/media/coins-solid.b0da6419.svg";